import React, { useEffect, useState, useRef } from 'react'
import apiFetch from '@wordpress/api-fetch'
import ScrollOut from 'scroll-out'
import SmallCounterBoxBlock from '../../small-counter/component/component'
import QuoteBlock from '../../quote/component/component'
import './styles.scss'

export default function PostsTeaserBlock({
  taxonomyType,
  category = 'All',
  countOption,
  countNumber,
  countUnit,
  countDescription,
  quoteContent,
  quoteSubtitle,
  site_lang,
}) {
  const [postsData, setPostsData] = useState([])
  const [pages, setPages] = useState(0)
  const [page, setPage] = useState(1)
  let posts_per_page = 7

  // console.log(theme_global_data.term)
  console.log(category)
  useEffect(() => {
    if (taxonomyType === 'tag') {
      apiFetch({
        path: `/wp-json/wp/v2/article?per_page=${posts_per_page}${
          category == 'All' ? '' : '&article-tag=' + category
        }&_embed&lang=${site_lang}`,
        parse: false,
      })
        .then(response => {
          setPages(response.headers.get('x-wp-totalpages'))
          setPage(1)
          return response.json()
        })
        .then(response => {
          setPostsData([...response])
        })
    } else {
      if (!category) {
        category = 'All'
      }
      apiFetch({
        path: `/wp-json/wp/v2/article?per_page=${posts_per_page}${
          category == 'All' ? '' : '&article-category=' + category
        }&_embed&lang=${site_lang}`,
        parse: false,
      })
        .then(response => {
          setPages(response.headers.get('x-wp-totalpages'))
          setPage(1)
          return response.json()
        })
        .then(response => {
          setPostsData([...response])
        })
    }
  }, [category])

  function loadmore() {
    if (page <= pages) {
      let buttonPagination = document.querySelectorAll(
        '.posts-teaser__loadmore-link'
      )
      let newpage = page + 1
      buttonPagination.forEach(element => {
        element.disabled = true
      })
      setPage(newpage)
      if (taxonomyType === 'tag') {
        apiFetch({
          path: `/wp-json/wp/v2/article?per_page=${posts_per_page}${
            category == 'All' ? '' : '&article-tag=' + category
          }${page && '&page=' + newpage}&_embed&lang=${site_lang}`,
          parse: false,
        })
          .then(response => response.json())
          .then(response => {
            setPostsData([...postsData, ...response])
            buttonPagination.forEach(element => {
              element.disabled = false
            })
          })
      } else {
        apiFetch({
          path: `/wp-json/wp/v2/article?per_page=${posts_per_page}${
            category == 'All' ? '' : '&article-category=' + category
          }${page && '&page=' + newpage}&_embed&lang=${site_lang}`,
          parse: false,
        })
          .then(response => response.json())
          .then(response => {
            setPostsData([...postsData, ...response])
            buttonPagination.forEach(element => {
              element.disabled = false
            })
          })
      }
    }
  }

  if (page == 1) {
    if (postsData.length < posts_per_page) {
      for (let i = 0; i < postsData.length; i++) {
        if (i == 2 && postsData[i].type != 'count') {
          let countObject = {
            type: 'count',
          }
          postsData.splice(i + 1, 0, countObject)
        } else if (i == 5 && postsData[i].type != 'quote') {
          let quoteObject = {
            type: 'quote',
          }
          postsData.splice(i + 1, 0, quoteObject)
        }
      }
    } else {
      for (let i = 0; i < postsData.length + 2; i++) {
        if (i == 2 && postsData[i].type != 'count') {
          let countObject = {
            type: 'count',
          }
          postsData.splice(i + 1, 0, countObject)
        } else if (i == 5 && postsData[i].type != 'quote') {
          let quoteObject = {
            type: 'quote',
          }
          postsData.splice(i + 1, 0, quoteObject)
        }
      }
    }
  }

  const ref = useRef()

  useEffect(() => {
    if (ref.current) {
      const so = ScrollOut({
        scope: ref.current,
        once: true,
        onShown(el) {
          el.classList.add('animated')
        },
      })
      return () => {
        so.teardown()
      }
    }
  }, [ref.current, postsData])

  return (
    <>
      <canvas id="bubbles-back"></canvas>
      {postsData && (
        <div className={'dhsv-posts-teaser-block'} ref={ref}>
          <div className="row">
            <div className="col-12">
              <div className="posts-teaser__inner">
                {postsData.map((item, key) => (
                  <>
                    {item.type === 'article' && (
                      <div
                        key={key}
                        className={`posts-teaser__wrap posts-teaser-anim`}
                        data-scroll
                      >
                        <a href={item.link}>
                          <div className="posts-teaser__item">
                            {item.featured_media != 0 && (
                              <img
                                src={
                                  item._embedded['wp:featuredmedia']['0']
                                    .source_url
                                }
                                className={'posts-teaser__item-image'}
                                alt={item.title.rendered}
                                title={item.title.rendered}
                              />
                            )}
                            {item.title.rendered && (
                              <div
                                className="posts-teaser__item-title"
                                dangerouslySetInnerHTML={{
                                  __html: item.title.rendered,
                                }}
                              />
                            )}
                            {item.excerpt.rendered && (
                              <div
                                className="posts-teaser__item-desc"
                                dangerouslySetInnerHTML={{
                                  __html: item.excerpt.rendered,
                                }}
                              />
                            )}
                          </div>
                        </a>
                      </div>
                    )}
                    {item.type === 'count' &&
                      (countNumber || countDescription) && (
                        <div
                          className="posts-teaser__item posts-teaser-anim"
                          key={key}
                          data-scroll
                        >
                          <SmallCounterBoxBlock
                            count={countOption}
                            number={countNumber}
                            unit={countUnit}
                            description={countDescription}
                          />
                        </div>
                      )}
                    {item.type === 'quote' && quoteContent && (
                      <div
                        className="posts-teaser__item posts-teaser__item--full"
                        key={key}
                        data-scroll
                      >
                        <QuoteBlock
                          quote={quoteContent}
                          subline={quoteSubtitle}
                        />
                      </div>
                    )}
                  </>
                ))}
              </div>
              {pages > 1 && page < pages && (
                <div className="posts-teaser__loadmore">
                  <button
                    className="posts-teaser__loadmore-button"
                    onClick={loadmore}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                    >
                      <g
                        id="Mehr_laden"
                        data-name="Mehr laden"
                        transform="translate(-20.9 -20.9)"
                      >
                        <g
                          id="Group_338"
                          data-name="Group 338"
                          transform="translate(20.9 20.9)"
                        >
                          <path
                            id="Path_16"
                            data-name="Path 16"
                            d="M45.9,20.9a25,25,0,1,0,25,25A25.009,25.009,0,0,0,45.9,20.9Z"
                            transform="translate(-20.9 -20.9)"
                          />
                        </g>
                        <path
                          id="Path_17"
                          data-name="Path 17"
                          d="M48.6,29V42.6H62.2v5.457H48.6V61.7H43.141V48.059H29.5V42.6H43.141V29Z"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
